import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import _ from "lodash"
import Title from "../general/title"
import clone from "clone"
import moment from "moment"
import colorArray from "helpers/colorArray"
import { Pie } from "react-chartjs-2"
import helpers from "helpers/helpers"
import numeral from "numeral"
import { toast } from "react-toastify"
import GroupedBar from "components/GroupedBar"
import ImageExport from "components/ImageExport"
import TrafficSources from "widgets/trafficSources"
import TrafficSourcesTraffic from "widgets/trafficSourcesTraffic"
import Chart from "react-apexcharts"
import FullTable from "components/FullTable"
import submitData from "helpers/submitData"
import currentUser from "helpers/currentUser"
import settings from "settings"
import generateTimes from "helpers/times"
import InfoDetail from "components/InfoDetail"

class Traffic extends Component {
	constructor(props) {
		super(props)

		this.state = {
			buckets: {},
			builderBuckets: {},
			copilotTraffic: [],
			totals: {},
			groupYoY: false,
			isorted: [],
			gsorted: [],
			gcolumns: [
				{
					Header: "ID",
					accessor: "id",
					filterMethod: (f, r) => helpers.tableText(f, r, "id"),
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Salesperson",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Prospect Count",
					accessor: "prospect_count",
					Cell: (v) => {
						if (!v.value) {
							return 0
						}
						return v.value
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.prospect_count
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Realtor Count",
					accessor: "realtor_count",
					Cell: (v) => {
						if (!v.value) {
							return 0
						}
						return v.value
					},
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.realtor_count
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Event",
					accessor: "event",
					filterMethod: (f, r) => helpers.tableText(f, r, "event"),
				},
				{
					Header: "Event Source",
					accessor: "event_source",
					filterMethod: (f, r) => helpers.tableText(f, r, "event_source"),
				},
				{
					Header: "Traffic Source",
					accessor: "source",
					filterMethod: (f, r) => helpers.tableText(f, r, "source"),
				},
				{
					Header: "Traffic Date",
					accessor: "date",
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("M/DD/YY")
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Entered Date",
					accessor: "entered",
					Cell: (v) => {
						return moment.unix(v.value).format("M/DD/YY h:mm A")
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
			],
			copilotColumns: [
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "First Name",
					accessor: "first_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "first_name"),
				},
				{
					Header: "Last Name",
					accessor: "last_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "last_name"),
				},
				{
					Header: "Email",
					accessor: "email",
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Zip",
					accessor: "zip",
					filterMethod: (f, r) => helpers.tableText(f, r, "zip"),
				},
				{
					Header: "Traffic Source",
					accessor: "source",
					filterMethod: (f, r) => helpers.tableText(f, r, "source"),
				},
				{
					Header: "Is Realtor",
					accessor: "is_realtor",
					filterMethod: (f, r) => helpers.tableText(f, r, "is_realtor"),
				},
				{
					Header: "Realtor License",
					accessor: "realtor_license",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_license"),
				},
				{
					Header: "Brokerage License",
					accessor: "brokerage_license",
					filterMethod: (f, r) => helpers.tableText(f, r, "brokerage_license"),
				},
				{
					Header: "Traffic Date",
					accessor: "date",
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("M/DD/YY")
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
			],
			realtorEmployeeColumns: [
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "First Name",
					accessor: "first_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "first_name"),
				},
				{
					Header: "Last Name",
					accessor: "last_name",
					filterMethod: (f, r) => helpers.tableText(f, r, "last_name"),
				},
				{
					Header: "Email",
					accessor: "email",
					filterMethod: (f, r) => helpers.tableText(f, r, "email"),
				},
				{
					Header: "Zip",
					accessor: "zip",
					filterMethod: (f, r) => helpers.tableText(f, r, "zip"),
				},
				{
					Header: "Traffic Source",
					accessor: "source",
					filterMethod: (f, r) => helpers.tableText(f, r, "source"),
				},
				{
					Header: "Is Realtor",
					accessor: "is_realtor",
					filterMethod: (f, r) => helpers.tableText(f, r, "is_realtor"),
				},
				{
					Header: "Realtor License",
					accessor: "realtor_license",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_license"),
				},
				{
					Header: "Traffic Date",
					accessor: "date",
					Cell: (v) => {
						if (v.value) return moment.unix(v.value).format("M/DD/YY")
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Notes",
					accessor: "notes",
					filterMethod: (f, r) => helpers.tableText(f, r, "notes"),
				},
			],
			currentWeek: [
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Weekly Traffic",
					accessor: "weekly_traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "weekly_traffic"),
					Footer: (props) => helpers.tableTotals(props, "weekly_traffic", "0,0"),
					Cell: (v) => {
						if (v.value === 0) return "-"
						return v.value
					},
				},
				{
					Header: "Previous Week",
					accessor: "previous_week",
					filterMethod: (f, r) => helpers.tableText(f, r, "previous_week"),
					Footer: (props) =>
						helpers.tableTotals(props, "previous_week", "0,0", { lookatField: "val_previous_week" }),
					Cell: (v) => {
						if (v.value === 0) return "-"
						return v.value
					},
				},
				{
					Header: "YTD Traffic",
					accessor: "ytd_traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "ytd_traffic"),
					Footer: (props) => helpers.tableTotals(props, "ytd_traffic", "0,0"),
					Cell: (v) => {
						if (v.value === 0) return "-"
						return v.value
					},
				},
				{
					Header: "Prev YTD Traffic",
					accessor: "prev_ytd_traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "prev_ytd_traffic"),
					Footer: (props) =>
						helpers.tableTotals(props, "prev_ytd_traffic", "0,0", { lookatField: "val_prev_ytd_traffic" }),
					Cell: (v) => {
						if (v.value === 0) return "-"
						return v.value
					},
				},
				{
					Header: "TTM Traffic",
					accessor: "ttm_traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "ttm_traffic"),
					Footer: (props) => helpers.tableTotals(props, "ttm_traffic", "0,0"),
					Cell: (v) => {
						if (v.value === 0) return "-"
						return v.value
					},
				},
				{
					Header: "Prev TTM Traffic",
					accessor: "prev_ttm_traffic",
					filterMethod: (f, r) => helpers.tableText(f, r, "prev_ttm_traffic"),
					Footer: (props) =>
						helpers.tableTotals(props, "prev_ttm_traffic", "0,0", { lookatField: "val_prev_ttm_traffic" }),
					Cell: (v) => {
						if (v.value === 0) return "-"
						return v.value
					},
				},
			],
			user: currentUser(),
			allTraffic: {
				detailed: [],
				grouped: [],
			},
		}
		if (this.state?.user?.super) {
			this.state.gcolumns.push({
				Header: "Delete",
				accessor: "delete",
			})
		}
	}
	componentDidMount() {
		this.pullAllTraffic()
		this.compileData()
		this.compileTotals()
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.compileData()
			this.compileTotals()
		}
		if (prevProps.activeProperties !== this.props.activeProperties) {
			this.pullAllTraffic()
		}
	}

	buildDetailedColumns = () => {
		let property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
		// custom fields
		let customs = []
		if (settings.detailedTrafficFields) {
			_.forEach(settings.detailedTrafficFields, (v) => {
				if (_.has(v, "properties")) {
					if (_.includes(v.properties, this.props.activeProperties[0])) {
						customs.push({
							Header: v.name,
							accessor: v.id,
							filterMethod: (f, r) => helpers.tableText(f, r, v.id),
						})
					}
				}
			})
		}
		let columns = [
			{
				Header: "ID",
				accessor: "id",
				filterMethod: (f, r) => helpers.tableText(f, r, "id"),
			},
			{
				Header: "Property",
				accessor: "property",
				filterMethod: (f, r) => helpers.tableText(f, r, "property"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
			},
			{
				Header: "Traffic Source",
				accessor: "source",
				filterMethod: (f, r) => helpers.tableText(f, r, "source"),
			},
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: "First Name",
				accessor: "first_name",
				filterMethod: (f, r) => helpers.tableText(f, r, "first_name"),
			},
			{
				Header: "Last Name",
				accessor: "last_name",
				filterMethod: (f, r) => helpers.tableText(f, r, "last_name"),
			},
			{
				Header: "Email",
				accessor: "email",
				filterMethod: (f, r) => helpers.tableText(f, r, "email"),
			},
			{
				Header: "Phone",
				accessor: "phone",
				filterMethod: (f, r) => helpers.tableText(f, r, "phone"),
			},
			{
				Header: "Zip",
				accessor: "zip",
			},
			{
				Header: "Is A Realtor",
				accessor: "realtor",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtor"),
			},
			{
				Header: "Host",
				accessor: "host",
				filterMethod: (f, r) => helpers.tableText(f, r, "host"),
			},
			{
				Header: "Event",
				accessor: "event",
				filterMethod: (f, r) => helpers.tableText(f, r, "event"),
			},
			...(customs.length ? [...customs] : []),
			...(property?.copilot
				? [
						{
							Header: "Copilot",
							columns: [
								{
									Header: "Return Visit",
									accessor: "return_visit",
									filterMethod: (f, r) => helpers.tableText(f, r, "return_visit"),
								},
								{
									Header: "Copilot Used",
									accessor: "copilot",
									filterMethod: (f, r) => helpers.tableText(f, r, "copilot"),
								},
							],
						},
				  ]
				: []),
			{
				Header: "Traffic Date",
				accessor: "date",
				Cell: (v) => {
					if (v.value) return moment.unix(v.value).format("M/DD/YY")
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Entered Date",
				accessor: "entered",
				Cell: (v) => {
					if (v.value) return moment.unix(v.value).format("M/DD/YY")
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
		]
		if (this.state?.user?.super) {
			columns.push({
				Header: "Delete",
				accessor: "delete",
			})
		}
		return columns
	}

	pullAllTraffic = async () => {
		this.props.loadingStatus(true)
		let resp = await submitData("mainRetrieve", {
			properties: this.props.activeProperties,
			action: "allTraffic",
		})
		if (resp.status === 200 && resp.data) {
			this.setState({ allTraffic: resp.data })
		} else {
			console.error("Cannot get traffic.")
		}
		if (settings?.enabled?.copilotScansTable) {
			let resp = await submitData("mainRetrieve", {
				properties: _.map(this.props.payload.public.properties, (v) => v.id),
				action: "allTraffic",
			})
			let d = resp.data.detailed
			d = _.filter(d, (v) => v.copilot && v.traffic_date >= this.props.currentDates.startStamp)
			if (resp.status === 200 && resp.data) {
				this.setState({ copilotTraffic: d })
			} else {
				console.error("Cannot get traffic.")
			}
		}
		this.props.loadingStatus(false)
	}

	createYears = () => {
		let start = moment(this.props.currentDates.start).unix()
		start = moment.unix(start).format("Y")
		let end = moment(this.props.currentDates.end).unix()
		end = moment.unix(end).format("Y")
		let years = {}
		for (let i = start; i <= end; i++) {
			i = parseInt(i)
			years[i] = 0
		}

		return years
	}

	compileData = () => {
		let data = {}
		let dataBuilder = {}
		// Create years out of current dates
		let years = this.createYears()

		let merged = [...this.props.payload.exec.traffic.individual, ...this.props.payload.exec.traffic.grouped]
		let sorted = {} // for original builder + lot type
		let builderSorted = {} // for just builders

		// Group both individual and grouped to form totals for each Builder+LotSize Combo
		for (let property of this.props.activeProperties) {
			data[property] = {}
			dataBuilder[property] = {}
			for (let row of merged) {
				if (row.property !== property) {
					continue
				}
				try {
					let yrs = clone(years)
					let yrsBuilder = clone(years)
					let trafficYear = moment.unix(row.traffic_date).format("Y")
					// Check if welcome cneter
					if (row.welcomeCenter && row.event) {
						if (!_.has(data, `${property}['Event']`)) {
							let y = {
								display: true,
								data: yrs,
							}
							_.set(data, `${property}['Event']`, y)
						}
						if (_.has(row, "prospect_count")) {
							// group, add them onto it
							data[property]["Event"]["data"][trafficYear] += row.prospect_count + row.realtor_count
						} else {
							// single traffic row, increase by one
							data[property]["Event"]["data"][trafficYear]++
						}
						continue
					} else if (row.welcomeCenter) {
						if (!_.has(data, `${property}['Welcome Center']`)) {
							let y = {
								display: true,
								data: yrs,
							}
							_.set(data, `${property}['Welcome Center']`, y)
						}
						if (_.has(row, "prospect_count")) {
							// group, add them onto it
							data[property]["Welcome Center"]["data"][trafficYear] +=
								row.prospect_count + row.realtor_count
						} else {
							// single traffic row, increase by one
							data[property]["Welcome Center"]["data"][trafficYear]++
						}
						continue
					}
					let type = _.find(this.props.payload.public.lot_types, { id: row.lot_type })
					//if (!type) throw `Cannot find type: ${row.id} - ${JSON.stringify(row)}`
					let builder = _.find(this.props.payload.public.builders, { id: row.builder })
					if (!builder) throw `Cannot find builder: ${row.id}`
					let size
					let name
					let builderName
					if (type) {
						size = _.find(this.props.payload.public.lot_sizes, { id: type.size })
						name = `${builder.name.replace(/[^\w- ]+/g, "")} - ${size.name}`
						builderName = `${builder.name.replace(/[^\w- ]+/g, "")}`
					} else {
						name = `${builder.name} - Unspecified`
						builderName = "Unspecified"
					}
					// Builder + lot type
					if (!_.has(data, `${property}.${name}`)) {
						let y = {
							display: true,
							data: yrs,
						}
						_.set(data, `${property}.${name}`, y)
					}
					// Builder
					if (!_.has(dataBuilder, `${property}.${builderName}`)) {
						let y = {
							display: true,
							data: yrsBuilder,
						}
						_.set(dataBuilder, `${property}.${builderName}`, y)
					}
					if (_.has(row, "prospect_count")) {
						// group, add them onto it
						data[property][name]["data"][trafficYear] += row.prospect_count + row.realtor_count
						dataBuilder[property][builderName]["data"][trafficYear] +=
							row.prospect_count + row.realtor_count
					} else {
						// single traffic row, increase by one
						data[property][name]["data"][trafficYear]++
						dataBuilder[property][builderName]["data"][trafficYear]++
					}
				} catch (err) {
					console.log(err)
				}
			}
		}
		// Chop welcome center off if blank all years
		_.forEach(data, (row, property) => {
			if (row["Welcome Center"] || row["Event"]) {
				let chop = true
				_.forEach(row["Welcome Center"]?.data, (v) => {
					if (v > 0) {
						chop = false
					}
				})
				if (chop) {
					delete data[property]["Welcome Center"]
				}
				chop = true
				_.forEach(row["Event"]?.data, (v) => {
					if (v > 0) {
						chop = false
					}
				})
				if (chop) {
					delete data[property]["Event"]
				}
			}
		})
		_.forEach(dataBuilder, (row, property) => {
			if (row["Welcome Center"] || row["Event"]) {
				let chop = true
				_.forEach(row["Welcome Center"]?.data, (v) => {
					if (v > 0) {
						chop = false
					}
				})
				if (chop) {
					delete dataBuilder[property]["Welcome Center"]
				}
				chop = true
				_.forEach(row["Event"]?.data, (v) => {
					if (v > 0) {
						chop = false
					}
				})
				if (chop) {
					delete dataBuilder[property]["Event"]
				}
			}
		})
		let keys = _.keys(data)
		keys = keys.sort()
		_.forEach(keys, (v) => {
			sorted[v] = data[v]
		})

		keys = _.keys(dataBuilder)
		keys = keys.sort()
		_.forEach(keys, (v) => {
			builderSorted[v] = dataBuilder[v]
		})

		this.setState({ buckets: sorted, builderBuckets: builderSorted })
	}

	compileTotals = () => {
		//? The unique welcome and detailed will not equal the unique detailed.  This is due to there being someone that comes into the welcome center, then goes to a builder.  That person isn't unique to either bucket, but can be in both.
		let ret = {
			detailed: this.props.payload.exec.traffic.individual.length,
			prospects: 0,
			grouped: 0,
			realtor: 0,
			welcomeProspect: 0,
			welcomeRealtor: 0,
			eventProspect: 0,
			eventRealtor: 0,
			builderProspectTraffic: 0,
			builderRealtor: 0,
			copilot: 0,
			detailed_unique: _.uniqBy(this.props.payload.exec.traffic.individual, "email").length,
			unique_prospect_builder: 0,
			unique_prospect_welcome: 0,
			unique_welcome_realtors: 0,
			unique_event_realtors: 0,
			unique_builder_realtors: 0,
		}

		let uniqueStore = {
			builder_prospects: [],
			welcome_prospects: [],
			welcome_realtors: [],
			event_realtors: [],
			builder_realtors: [],
		}
		_.forEach(this.props.payload.exec.traffic.individual, (v) => {
			if (v.welcomeCenter && v.is_realtor) {
				ret.welcomeRealtor++
			}
			if (v.welcomeCenter && !v.is_realtor) {
				ret.welcomeProspect++
			}
			if (!v.welcomeCenter && v.is_realtor) {
				ret.builderRealtor++
			}
			if (!v.welcomeCenter && !v.is_realtor) {
				ret.builderProspectTraffic++
			}
			if (v.is_realtor) {
				ret.realtor++
			} else {
				ret.prospects++
			}
			if (v.copilot) ret.copilot++

			// Unique array building
			if (
				v.builder &&
				!v.welcomeCenter &&
				!v.is_realtor &&
				!_.find(uniqueStore.builder_prospects, (r) => r.email === v.email)
			) {
				uniqueStore.builder_prospects.push(v)
			}
			if (
				!v.builder &&
				v.welcomeCenter &&
				!v.is_realtor &&
				!_.find(uniqueStore.welcome_prospects, (r) => r.email === v.email)
			) {
				uniqueStore.welcome_prospects.push(v)
			}
			if (v.welcomeCenter && v.is_realtor && !_.find(uniqueStore.welcome_realtors, (r) => r.email === v.email)) {
				uniqueStore.welcome_realtors.push(v)
			}
			if (v.event && v.is_realtor && !_.find(uniqueStore.event_realtors, (r) => r.email === v.email)) {
				uniqueStore.event_realtors.push(v)
			}
			if (
				!v.welcomeCenter &&
				v.is_realtor &&
				v.builder &&
				!_.find(uniqueStore.builder_realtors, (r) => r.email === v.email)
			) {
				uniqueStore.builder_realtors.push(v)
			}
		})
		ret.unique_prospect_builder = uniqueStore.builder_prospects.length
		ret.unique_prospect_welcome = uniqueStore.welcome_prospects.length
		ret.unique_welcome_realtors = uniqueStore.welcome_realtors.length
		ret.unique_event_realtors = uniqueStore.event_realtors.length
		ret.unique_builder_realtors = uniqueStore.builder_realtors.length

		//? There's confusion around welcome center and event traffic.  Event traffic is always welcome center, but not vice versa.
		_.forEach(this.props.payload.exec.traffic.grouped, (v) => {
			ret.grouped += v.prospect_count + v.realtor_count
			ret.realtor += v.realtor_count
			ret.prospects += v.prospect_count
			if (v.event && v.welcomeCenter) {
				ret.eventProspect += v.prospect_count
				ret.eventRealtor += v.realtor_count
			} else if (v.welcomeCenter) {
				ret.welcomeProspect += v.prospect_count
				ret.welcomeRealtor += v.realtor_count
			} else {
				ret.builderProspectTraffic += v.prospect_count
				ret.builderRealtor += v.realtor_count
			}
		})
		this.setState({ totals: ret })
	}

	filterChange = (i, property) => {
		let buckets = clone(this.state.buckets)
		buckets[property][i].display = !buckets[property][i].display
		this.setState({ buckets })
	}

	renderFilters = (property) => {
		let checkboxes = []
		_.forEach(this.state.buckets[property], (v, k) => {
			//let index = _.findIndex(this.state.buckets[property], { Header: v.Header })
			checkboxes.push(
				<li
					className="filterCheckboxes__item"
					key={`${property}-${k}`}
					data-value={k}
					onClick={() => {
						this.filterChange(k, property)
					}}>
					<input
						type="checkbox"
						name={k}
						value={k}
						checked={this.state.buckets[property][k].display}
						onChange={() => {}}
					/>
					{k}
				</li>
			)
		})

		return checkboxes
	}

	checkAll = (property, value) => {
		let buckets = clone(this.state.buckets)
		_.forEach(buckets[property], (v) => {
			v.display = value
		})
		this.setState({ buckets })
	}

	delete = (id, type) => {
		let v = {}
		v.action = "deleteTraffic"
		v.id = id
		v.type = type
		this.props.loadingStatus(true)
		submitData("mainIngest", v).then((data) => {
			this.props.loadingStatus(false)
			toast.success("Traffic entry has been deleted.")
			this.props.getPayload()
		})
	}

	buildIndividualTable = () => {
		let ret = []

		_.forEach(this.props.payload.exec.traffic.individual, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let salesperson = _.find(this.props.payload.public.salespeople, { id: v.salesperson })
			let source = _.find(this.props.payload.public.trafficSources, { id: v.source })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let lot
			if (v.lot_id) {
				lot = _.find(this.props.payload.exec.lots, { id: v.lot_id })
			}
			if (v.welcomeCenter) {
				builder = {
					name: "Welcome Center",
				}
			}
			let host
			// Check the primary buyer email for host first
			if (v.host) host = _.find(this.props.payload.public.info_center_users, { id: v.host })

			//? Check for returning visitor on copilot properties
			// Check model first
			let returning = false
			// This is commeneted out because it doesn't matter if htey're going to welcome or builder, returning now just looks at whether they came back to the same property at a different date.  Probably safe to delete.
			/* if (property?.copilot) {
				if (v.lot_id) {
					let lookupPrevious = _.find(this.props.payload.exec.traffic.individual, {
						lot_id: v.lot_id,
						email: v.email,
					})
					if (lookupPrevious && lookupPrevious.traffic_date < v.traffic_date) returning = true
				} else if (v.welcomeCenter) {
					let lookupPrevious = _.find(this.props.payload.exec.traffic.individual, {
						welcomeCenter: 1,
						email: v.email,
						property: v.property,
					})
					if (lookupPrevious && lookupPrevious.traffic_date < v.traffic_date) returning = true
				}
			} */
			let lookupPrevious = _.find(this.props.payload.exec.traffic.individual, {
				email: v.email,
			})
			if (lookupPrevious) {
				let previousDate = moment.unix(lookupPrevious.traffic_date).format("M/DD/YY")
				let thisDate = moment.unix(v.traffic_date).format("M/DD/YY")
				if (previousDate !== thisDate) returning = true
			}
			let f = {
				id: v.id,
				builder: builder ? builder.name : "",
				salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
				source: source ? source.name : "",
				property: property ? property.name : "",
				first_name: v.first_name,
				size: v.size,
				lot_type: type ? type.name : "",
				last_name: v.last_name,
				email: v.email,
				zip: v.zip,
				phone: v.phone,
				realtor: v.is_realtor == 1 ? "Yes" : "No",
				copilot: v.copilot ? "Yes" : "No",
				date: v.traffic_date,
				entered: v.addedDate,
				host: host ? `${host.first} ${host.last}` : "",
				event: v.event || null,
				address: lot ? lot.address : "",
				...(property?.copilot ? { return_visit: returning ? "Yes" : "No" } : {}),
				delete: (
					<a
						onClick={() => {
							this.delete(v.id, "traffic")
						}}>
						<i className="fa-solid fa-trash-xmark text-red-500"></i>
					</a>
				),
			}
			if (v.addl) {
				_.forEach(v.addl, (addl, key) => {
					if (addl === 1) f[key] = "Yes"
					else if (addl === 0) f[key] = "No"
					else f[key] = addl
				})
			}
			ret.push(f)
		})
		return ret
	}

	buildGroupedTable = () => {
		let ret = []

		_.forEach(this.props.payload.exec.traffic.grouped, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let salesperson = _.find(this.props.payload.public.salespeople, { id: v.user })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let source = _.find(this.props.payload.public.trafficSources, { id: v.source })
			if (v.welcomeCenter) {
				builder = {
					name: "Welcome Center",
				}
			}
			ret.push({
				id: v.id,
				builder: builder ? builder.name : "",
				salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
				property: property ? property.name : "",
				prospect_count: v.prospect_count,
				realtor_count: v.realtor_count,
				lot_type: type ? type.name : "",
				event: v.event ? "Yes" : "No",
				event_source: v.event && v.description ? v.description : "",
				source: source ? source.name : "",
				date: v.traffic_date,
				entered: v.addedDate,
				delete: (
					<a
						onClick={() => {
							this.delete(v.id, "traffic_grouped")
						}}>
						<i className="fa-solid fa-trash-xmark text-red-500"></i>
					</a>
				),
			})
		})
		return ret
	}

	generateDetailedCharts = () => {
		return _.map(this.props.activeProperties, (property) => {
			let pInfo = _.find(this.props.payload.public.properties, { id: property })
			let values = this.state.buckets[property]
			let d = {}
			let labels = []
			let years = this.createYears()

			_.forEach(years, (v, year) => {
				year = year.toString()
				d[year] = []
				_.forEach(values, (builderData) => {
					if (builderData.display === false) {
						return
					}
					d[year].push(builderData.data[year])
				})
			})
			// Generate labels
			_.forEach(values, (v, k) => {
				if (v.display) {
					labels.push(k)
				}
			})
			// Some say keys are not guaranteed to be in order, so this may be an issue if this ever arises.
			let keys = _.keys(years)

			let datasets = []
			let i = 0
			_.forEach(years, (v) => {
				let obj = {
					label: keys[i],
					backgroundColor: colorArray[i],
					borderColor: colorArray[i],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d[keys[i]],
				}
				datasets.push(obj)
				i++
			})

			const data = {
				labels: labels,
				datasets: datasets,
			}
			let sortedLabels = helpers.orderByLotType(labels, data.datasets[0].data)
			_.forEach(data.datasets, (v, k) => {
				let sorted = helpers.orderByLotType(labels, v.data)
				data.datasets[k].data = sorted.data
			})
			data.labels = sortedLabels.labels

			let series = _.map(data.datasets, (v) => {
				return {
					name: v.label,
					data: v.data,
				}
			})

			// Create total boxes
			let totals = _.map(years, (v, k) => {
				let sum = _.sum(d[k])
				if (sum) {
					sum = sum.toLocaleString()
				}

				return (
					<li key={k}>
						<span>{k}</span>
						<span>{sum}</span>
					</li>
				)
			})

			let toggle = () => {
				this.setState({ groupYoY: !this.state.groupYoY })
			}
			return (
				<div key={property} style={{ marginBottom: 70 }}>
					<ImageExport name="TrafficByBuilderLotType" block={true} />
					<ul className="totalBoxes">{totals}</ul>
					<div className="titleFilter">
						<h3>{pInfo.name}</h3>
						<p className="filterCheck">
							<span onClick={() => this.checkAll(property, true)}>Check All</span>
							<span onClick={() => this.checkAll(property, false)}>Uncheck All</span>
						</p>
					</div>
					<div className="filterCheckboxes__cont">
						<p className="filterCheckboxes__toggle" onClick={() => toggle()} data-html2canvas-ignore="true">
							{this.state.groupYoY ? "Hide" : "Show"} Filters
						</p>
						{this.state.groupYoY && (
							<ul className="filterCheckboxes" data-html2canvas-ignore="true">
								{this.renderFilters(property)}
							</ul>
						)}
					</div>
					<h3>By Builder + Lot Type</h3>
					<div className="wideBar">
						<div className="wideBar__cont">
							{/* <Bar data={data} options={lineOptions} key={property} /> */}
							<GroupedBar series={series} categories={data.labels} colorful={false} />
						</div>
					</div>
				</div>
			)
		})
	}

	generateBuilderCharts = () => {
		return _.map(this.props.activeProperties, (property) => {
			let pInfo = _.find(this.props.payload.public.properties, { id: property })
			// This orders the object by key
			let values = _(this.state.builderBuckets[property]).toPairs().sortBy(0).fromPairs().value()
			let d = {}
			let labels = []
			let years = this.createYears()

			_.forEach(years, (v, year) => {
				year = year.toString()
				d[year] = []
				_.forEach(values, (builderData) => {
					if (builderData.display === false) {
						return
					}
					d[year].push(builderData.data[year])
				})
			})
			// Generate labels
			_.forEach(values, (v, k) => {
				if (v.display) {
					labels.push(k)
				}
			})
			// Some say keys are not guaranteed to be in order, so this may be an issue if this ever arises.
			let keys = _.keys(years)

			let datasets = []
			let i = 0
			_.forEach(years, (v) => {
				let obj = {
					label: keys[i],
					backgroundColor: colorArray[i],
					borderColor: colorArray[i],
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: d[keys[i]],
				}
				datasets.push(obj)
				i++
			})

			const data = {
				labels: labels,
				datasets: datasets,
			}

			let series = _.map(data.datasets, (v) => {
				return {
					name: v.label,
					data: v.data,
				}
			})

			let toggle = () => {
				this.setState({ groupYoY: !this.state.groupYoY })
			}
			return (
				<div key={property} style={{ marginBottom: 70 }}>
					<ImageExport name="TrafficByBuilder" block={true} />
					{/* <div className="filterCheckboxes__cont">
						<p className="filterCheckboxes__toggle" onClick={() => toggle()} data-html2canvas-ignore="true">
							{this.state.groupYoY ? "Hide" : "Show"} Filters
						</p>
						{this.state.groupYoY && (
							<ul className="filterCheckboxes" data-html2canvas-ignore="true">
								{this.renderFilters(property)}
							</ul>
						)}
					</div> */}
					<h3>{pInfo.name}</h3>
					<h3>By Builder</h3>
					<div className="wideBar">
						<div className="wideBar__cont">
							{/* <Bar data={data} options={lineOptions} key={property} /> */}
							<GroupedBar series={series} categories={data.labels} colorful={false} />
						</div>
					</div>
				</div>
			)
		})
	}

	numberOfVisits = () => {
		// First compile a list of all statuses
		let statuses = {
			1: 0,
			2: 0,
			3: 0,
			4: 0,
			"5+": 0,
		}
		let count = 0
		// First create an unique array of email addresses on the traffic
		let emailStore = {}
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			count++
			if (!_.has(emailStore, v.email)) {
				emailStore[v.email] = 0
			}
			emailStore[v.email]++
		})

		_.forEach(emailStore, (v) => {
			if (v >= 5) {
				statuses["5+"]++
			} else {
				statuses[v]++
			}
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Number of Visits{" "}
					<InfoDetail text="During the selected time range, number of visits by someone irregardless of day, builder, or welcome center.  Example: If Jane Doe visited the welcome center, went to two models, came back a week later and visited another model, Jane would be accounted for in the '4' pie slice." />
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Detailed Traffic: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	returningVisitors = () => {
		// First compile a list of all statuses
		let statuses = {
			2: 0,
			3: 0,
			4: 0,
			"5+": 0,
		}
		// First create an unique array of email addresses on the traffic
		let emailStore = {}
		let foo = _.filter(this.props.payload.traffic.current.entries, { email: "Hi@man.com" })
		let emails = _.uniqBy(this.props.payload.traffic.current.entries, "email")
		_.forEach(emails, (v) => {
			if (!_.has(emailStore, v.email)) {
				emailStore[v.email] = [moment.unix(v.traffic_date).format("M/DD/YY")]
			}
		})
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			let date = moment.unix(v.traffic_date).format("M/DD/YY")
			if (!emailStore[v.email].includes(date)) emailStore[v.email].push(date)
		})
		let store = {}
		_.forEach(emailStore, (v, k) => {
			if (v.length > 1) {
				store[k] = v.length
			}
		})
		_.forEach(store, (v) => {
			if (v >= 5) {
				statuses["5+"]++
			} else {
				statuses[v]++
			}
		})
		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		let num = _.keys(store).length

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Returning Visits{" "}
					<InfoDetail text="During the selected time range, number of times a prospect came back to the community at a different date, irregardless of builder or welcome center.  Example:  If Jane Doe came into the welcome center and then visited 3 models the same day, she'd still be in the '1' pie slice which is hidden.  If she then came back a week later and visited 3 models, she'd be moved to the '2' slice." />
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Returning Visitors: {num.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	busiestDays = (welcome) => {
		let days = {
			Monday: 0,
			Tuesday: 0,
			Wednesday: 0,
			Thursday: 0,
			Friday: 0,
			Saturday: 0,
			Sunday: 0,
		}
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			let day = moment.unix(v.traffic_date).format("dddd")
			if (welcome && v.welcomeCenter) {
				days[day]++
			} else if (!welcome && !v.welcomeCenter) {
				days[day]++
			}
		})
		_.forEach(this.props.payload.traffic.current.grouped.array, (v) => {
			let day = moment.unix(v.traffic_date).format("dddd")
			if (welcome && v.welcomeCenter) {
				days[day] += v.prospect_count
				days[day] += v.realtor_count
			} else if (!welcome && !v.welcomeCenter) {
				days[day] += v.prospect_count
				days[day] += v.realtor_count
			}
		})
		//console.log(welcome, _.sum(_.values(days)))

		let opts = {
			chart: {
				id: "basic-bar",
			},
			xaxis: {
				categories: _.keys(days),
			},
		}
		let series = [
			{
				name: "Visits",
				data: _.values(days),
			},
		]

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Busiest Days - {welcome ? "Welcome Center" : "Model Homes"}
				</h3>
				<Chart options={opts} series={series} type="bar" />
			</>
		)
	}

	buildCurrentWeek = () => {
		if (this.state.allTraffic.detailed?.length === 0 && this.state.allTraffic.grouped?.length === 0) return []
		let ret = []
		let model = {
			weekly_traffic: 0,
			previous_week: 0,
			ytd_traffic: 0,
			prev_ytd_traffic: 0,
			ttm_traffic: 0,
			prev_ttm_traffic: 0,
			// vals are for the table totals
			val_previous_week: 0,
			val_prev_ytd_traffic: 0,
			val_prev_ttm_traffic: 0,
		}
		let store = {}
		let times = generateTimes()
		let twoWeeksAgo = moment.unix(times.lastWeek).subtract(1, "week").unix()
		let twoWeeksAgoEnd = moment.unix(times.lastWeekEnd).subtract(1, "week").unix()
		let lastYear = moment().subtract(1, "year").startOf("year").unix()
		let prevTTM = moment.unix(times.currentPoint).subtract(1, "year").unix()
		_.forEach(this.state.allTraffic.detailed, (v) => {
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (v.welcomeCenter) {
				builder = {
					name: "Welcome Center",
				}
			}
			if (!property || !builder) {
				console.warn(`Cannot find property or builder for ${v.id}`)
				return
			}
			let builderName = helpers.safeBuilderName(builder.name)
			let p = property.name
			let b = builderName
			let path = `${p}.${b}`
			if (!_.has(store, path)) {
				_.set(store, path, _.clone(model))
			}
			// Weekly traffic for last week
			if (v.traffic_date >= times.lastWeek && v.traffic_date <= times.lastWeekEnd) {
				store[p][b].weekly_traffic++
			}
			// Previous week (to last week)
			if (v.traffic_date >= twoWeeksAgo && v.traffic_date <= twoWeeksAgoEnd) {
				store[p][b].previous_week++
			}
			// YTD Traffic - DOES NOT STOP AT LAST WEEK - should it?
			if (v.traffic_date >= times.thisYear) {
				store[p][b].ytd_traffic++
			}
			// Previous YTD Traffic - Jan 1 to exact second last year.  It's sept 26 2023 today, so current point is sept 26 2022
			if (v.traffic_date >= lastYear && v.traffic_date <= times.currentPoint) {
				store[p][b].prev_ytd_traffic++
			}
			// TTM Traffic - 12 months from current point
			if (v.traffic_date >= times.currentPoint) {
				store[p][b].ttm_traffic++
			}
			// Prev TTM - currentPoint - 12 months
			if (v.traffic_date >= prevTTM && v.traffic_date <= times.currentPoint) {
				store[p][b].prev_ttm_traffic++
			}
		})
		_.forEach(this.state.allTraffic.grouped, (v) => {
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (v.welcomeCenter) {
				builder = {
					name: "Welcome Center",
				}
			}
			if (!property || !builder) {
				console.warn(`Cannot find property or builder for ${v.id}`)
				return
			}
			let builderName = helpers.safeBuilderName(builder.name)
			let p = property.name
			let b = builderName
			let path = `${p}.${b}`
			if (!_.has(store, path)) {
				_.set(store, path, _.clone(model))
			}
			// Weekly traffic for last week
			if (v.traffic_date >= times.lastWeek && v.traffic_date <= times.lastWeekEnd) {
				store[p][b].weekly_traffic += v.prospect_count + v.realtor_count
			}
			// Previous week (to last week)
			if (v.traffic_date >= twoWeeksAgo && v.traffic_date <= twoWeeksAgoEnd) {
				store[p][b].previous_week += v.prospect_count + v.realtor_count
			}
			// YTD Traffic - DOES NOT STOP AT LAST WEEK - should it?
			if (v.traffic_date >= times.thisYear) {
				store[p][b].ytd_traffic += v.prospect_count + v.realtor_count
			}
			// Previous YTD Traffic - Jan 1 to exact second last year.  It's sept 26 2023 today, so current point is sept 26 2022
			if (v.traffic_date >= lastYear && v.traffic_date <= times.currentPoint) {
				store[p][b].prev_ytd_traffic += v.prospect_count + v.realtor_count
			}
			// TTM Traffic - 12 months from current point
			if (v.traffic_date >= times.currentPoint) {
				store[p][b].ttm_traffic += v.prospect_count + v.realtor_count
			}
			// Prev TTM - currentPoint - 12 months
			if (v.traffic_date >= prevTTM && v.traffic_date <= times.currentPoint) {
				store[p][b].prev_ttm_traffic += v.prospect_count + v.realtor_count
			}
		})
		_.forEach(store, (r1, property) => {
			_.forEach(r1, (v, builder) => {
				// Adjust the vals so we store hard numbers to be used in teh table totals...due to these being react elements to show the +/-
				v.val_previous_week = v.previous_week
				v.val_prev_ytd_traffic = v.prev_ytd_traffic
				v.val_prev_ttm_traffic = v.prev_ttm_traffic

				// Weekly
				if (v.weekly_traffic > v.previous_week) {
					v.previous_week = (
						<span>
							{v.previous_week} (
							<span className="text-green-600 font-bold">+{v.weekly_traffic - v.previous_week}</span>)
						</span>
					)
				} else if (v.weekly_traffic < v.previous_week) {
					v.previous_week = (
						<span>
							{v.previous_week} (
							<span className="text-red-500 font-bold">{v.weekly_traffic - v.previous_week}</span>)
						</span>
					)
				}
				// YTD
				if (v.ytd_traffic > v.prev_ytd_traffic) {
					v.prev_ytd_traffic = (
						<span>
							{v.prev_ytd_traffic} (
							<span className="text-green-600 font-bold">+{v.ytd_traffic - v.prev_ytd_traffic}</span>)
						</span>
					)
				} else if (v.ytd_traffic < v.prev_ytd_traffic) {
					v.prev_ytd_traffic = (
						<span>
							{v.prev_ytd_traffic} (
							<span className="text-red-500 font-bold">{v.ytd_traffic - v.prev_ytd_traffic}</span>)
						</span>
					)
				}
				// TTM
				if (v.ttm_traffic > v.prev_ttm_traffic) {
					v.prev_ttm_traffic = (
						<span>
							{v.prev_ttm_traffic} (
							<span className="text-green-600 font-bold">+{v.ttm_traffic - v.prev_ttm_traffic}</span>)
						</span>
					)
				} else if (v.ttm_traffic < v.prev_ttm_traffic) {
					v.prev_ttm_traffic = (
						<span>
							{v.prev_ttm_traffic} (
							<span className="text-red-500 font-bold">{v.ttm_traffic - v.prev_ttm_traffic}</span>)
						</span>
					)
				}
				ret.push({
					property,
					builder,
					...v,
				})
			})
		})
		//console.log(ret)
		return ret
	}

	buildCoPilotScans = () => {
		let ret = []

		_.forEach(this.state.copilotTraffic, (v) => {
			if (!v.copilot) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let salesperson = _.find(this.props.payload.public.salespeople, { id: v.salesperson })
			let source = _.find(this.props.payload.public.trafficSources, { id: v.source })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let lot
			if (v.lot_id) {
				lot = _.find(this.props.payload.exec.lots, { id: v.lot_id })
			}
			if (v.welcomeCenter) {
				builder = {
					name: "Welcome Center",
				}
			}
			ret.push({
				id: v.id,
				builder: builder ? builder.name : "",
				salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
				source: source ? source.name : "",
				property: property ? property.name : "",
				first_name: v.first_name,
				size: v.size,
				lot_type: type ? type.name : "",
				last_name: v.last_name,
				email: v.email,
				zip: v.zip,
				phone: v.phone,
				is_realtor: v.is_realtor == 1 ? "Yes" : "No",
				realtor: v.realtor,
				realtor_license: v.realtor,
				brokerage_license: v.realtor_office,
				date: v.traffic_date,
				entered: v.addedDate,
				address: lot ? lot.address : "",
			})
		})
		return ret
	}

	buildRealtorEmployeeActivity = () => {
		if(!Array.isArray(settings?.enabled?.realtorEmployees)) {
			return []
		}
		let ret = []
		_.forEach(this.props.payload.exec.traffic.individual, (v) => {
			if(!settings.enabled.realtorEmployees.includes(v.salesperson)) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let salesperson = _.find(this.props.payload.public.salespeople, { id: v.salesperson })
			let source = _.find(this.props.payload.public.trafficSources, { id: v.source })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			ret.push({
				id: v.id,
				builder: builder ? builder.name : "",
				salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
				source: source ? source.name : "",
				property: property ? property.name : "",
				first_name: v.first_name,
				size: v.size,
				lot_type: type ? type.name : "",
				last_name: v.last_name,
				email: v.email,
				zip: v.zip,
				phone: v.phone,
				is_realtor: v.is_realtor == 1 ? "Yes" : "No",
				realtor: v.realtor,
				realtor_license: v.realtor,
				brokerage_license: v.realtor_office,
				date: v.traffic_date,
				entered: v.addedDate,
				notes: v.notes
			})
		})
		return ret
	}

	coPilotBreakout = () => {
		let property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
		if (!property) return <></>
		if (!property.copilot) return <></>
		let welcomeCenter = 0
		let builder = 0
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			if (v.copilot && v.welcomeCenter) welcomeCenter++
			if (v.copilot && !v.welcomeCenter) builder++
		})
		// Pie data
		let store = {}
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (v.welcomeCenter || !builder) {
				return
			}
			let builderName = helpers.safeBuilderName(builder.name)
			if (!_.has(store, builderName)) {
				store[builderName] = 0
			}
			if (v.copilot) store[builderName]++
		})
		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}
		const data = {
			labels: _.keys(store),
			datasets: [
				{
					data: _.values(store),
					backgroundColor: colorArray,
				},
			],
		}

		return (
			<div className="lg:flex w-full">
				<div className="flex-1">
					<h3>Builder CoPilot Traffic</h3>
					<Pie data={data} options={opts} />
				</div>
				<div className="quickStats quickStats--light flex-1">
					<h3>Welcome vs. Builder</h3>
					<ul className="quickStats__list mx-0">
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">{welcomeCenter}</div>
								<div className="quickStats__type">Welcome Center</div>
							</div>
						</li>
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">{builder}</div>
								<div className="quickStats__type">Builder</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		)
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="">
					<div className="imageGroup">
						<Title title="Traffic" />
						<div className="content">
							<div className="quickStats" style={{ marginBottom: 50 }}>
								<h2 className="quickStats__subhead">Traffic Totals</h2>
								<ul className="quickStats__list">
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.detailed + this.state.totals.grouped).format(
													"0,0"
												)}
											</div>
											<div className="quickStats__type">Traffic Total</div>
										</div>
									</li>
									<li className="quickStats__equation">=</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat !text-[2.5rem]">
												{numeral(this.state.totals.detailed).format("0,0")}
												<span className="text-xl">
													/ {numeral(this.state.totals.detailed_unique).format("0,0")}
												</span>
											</div>
											<div className="quickStats__type">Detailed Traffic/Unique Traffic</div>
										</div>
									</li>
									<li className="quickStats__equation">+</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.grouped).format("0,0")}
											</div>
											<div className="quickStats__type">Grouped Traffic</div>
										</div>
									</li>
								</ul>
								<h2 className="quickStats__subhead">Additional Traffic Detail</h2>
								<ul className="quickStats__list">
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.builderProspectTraffic).format("0,0")}
											</div>
											<div className="quickStats__type">Builder Prospect Traffic</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.eventProspect).format("0,0")}
											</div>
											<div className="quickStats__type">Event Prospects</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.welcomeProspect).format("0,0")}
											</div>
											<div className="quickStats__type">Welcome Center Prospects</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.copilot).format("0,0")}
											</div>
											<div className="quickStats__type">CoPilot Traffic</div>
										</div>
									</li>
									<li className="quickStats__item lg:ml-10">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.eventRealtor).format("0,0")}
											</div>
											<div className="quickStats__type">Event Realtors</div>
										</div>
									</li>
									<li className="quickStats__equation px-0 mr-[15px]">+</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.welcomeRealtor).format("0,0")}
											</div>
											<div className="quickStats__type">Welcome Center Realtors</div>
										</div>
									</li>
									<li className="quickStats__equation px-0 mr-[15px]">+</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.builderRealtor).format("0,0")}
											</div>
											<div className="quickStats__type">Builder Realtors</div>
										</div>
									</li>
									<li className="quickStats__equation px-0 mr-[15px]">=</li>
									<li className="quickStats__item quickStats--light">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.realtor).format("0,0")}
											</div>
											<div className="quickStats__type">Total Realtor</div>
										</div>
									</li>
								</ul>
								<h2 className="quickStats__subhead">Unique Traffic Detail</h2>
								<div className="w-[90%] mx-auto">
									<p className="text-xs">
										Detailed traffic that has been de-duped. Cannot take{" "}
										<strong>grouped traffic</strong> into consideration.
									</p>
								</div>
								<ul className="quickStats__list">
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.unique_prospect_builder).format("0,0")}
											</div>
											<div className="quickStats__type">Builder Prospect Traffic</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.unique_prospect_welcome).format("0,0")}
											</div>
											<div className="quickStats__type">Welcome Center Prospects</div>
										</div>
									</li>
									<li className="quickStats__item lg:ml-10">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.unique_welcome_realtors).format("0,0")}
											</div>
											<div className="quickStats__type">Welcome Center Realtors</div>
										</div>
									</li>
									<li className="quickStats__equation px-0 mr-[15px]">+</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">
												{numeral(this.state.totals.unique_builder_realtors).format("0,0")}
											</div>
											<div className="quickStats__type">Builder Realtors</div>
										</div>
									</li>
									<li className="quickStats__equation px-0 mr-[15px]">=</li>
									<li className="quickStats__item quickStats--light">
										<div>
											<div className="quickStats__stat">
												{numeral(
													this.state.totals.unique_builder_realtors +
														this.state.totals.unique_welcome_realtors
												).format("0,0")}
											</div>
											<div className="quickStats__type">Total Realtor</div>
										</div>
									</li>
								</ul>
							</div>
							<div className="statBox__row statBox__row--quad">
								<div className="statBox__box">{this.numberOfVisits()}</div>
								<div className="statBox__box">{this.returningVisitors()}</div>
								<div className="statBox__box">{this.busiestDays()}</div>
								<div className="statBox__box">{this.busiestDays(true)}</div>
							</div>
							<div className="xl:flex">
								<div className="flex-1">{this.generateDetailedCharts()}</div>
								<div className="flex-1 xl:pl-5">{this.generateBuilderCharts()}</div>
							</div>
							<div>
								<div className="flex-1 xl:flex">
									<div className="flex-1">
										<TrafficSources {...this.props} />
									</div>
									<div className="flex-1">
										<TrafficSourcesTraffic {...this.props} />
									</div>
								</div>
							</div>
							{this.coPilotBreakout()}
							<div>
								<h2>Detailed Traffic</h2>
								<FullTable
									data={this.buildIndividualTable()}
									columns={this.buildDetailedColumns()}
									name="traffic__detailed"
									title="Detailed Traffic"
									unset={["delete"]}
									defaultSorted={[
										{
											id: "date",
											desc: true,
										},
									]}
								/>
							</div>
							<div>
								<h2>Grouped Traffic</h2>
								<FullTable
									data={this.buildGroupedTable()}
									columns={this.state.gcolumns}
									name="traffic__grouped"
									title="Grouped Traffic"
									unset={["delete"]}
									defaultSorted={[
										{
											id: "date",
											desc: true,
										},
									]}
								/>
							</div>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h3>Last Weeks Traffic Stats</h3>
							<FullTable
								data={this.buildCurrentWeek()}
								columns={this.state.currentWeek}
								pageSize={15}
								name="traffic__lastWeek"
								title="Last Week Traffic"
							/>
						</div>
					</div>
					{settings?.enabled?.copilotScansTable && (
						<div className="imageGroup">
							<div className="content">
								<h3>CoPilot Scans</h3>
								<FullTable
									data={this.buildCoPilotScans()}
									columns={this.state.copilotColumns}
									pageSize={15}
									name="traffic__copilotScans"
									title="CoPilot Scans"
								/>
							</div>
						</div>
					)}
					{settings?.enabled?.realtorEmployees && (
						<div className="imageGroup">
							<div className="content">
								<h3>Realtor Activity Tracking</h3>
								<FullTable
									data={this.buildRealtorEmployeeActivity()}
									columns={this.state.realtorEmployeeColumns}
									pageSize={15}
									name="traffic__realtorEmployeeActivity"
									title="Realtor Employee Activity"
								/>
							</div>
						</div>
					)}
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(Traffic)
